<template>
  <ll-new-modal
    :open="open"
    title="保存方案"
    :mask-closable="false"
    :z-index="1050"
    @cancel="emits('cancel')"
    @ok="onSave"
  >
    <div :style="{ padding: '24px 40px 0' }">
      <ll-form
        ref="formRef"
        :form-columns="formCols"
        :form-data="formData"
        :form-options="{ layout: 'horizontal' }"
      />
    </div>
  </ll-new-modal>
</template>
<script setup lang="ts">
import { ref } from 'vue'

defineOptions({ name: 'CustomSearcherSchemeName' })

const formCols = ref([
  {
    label: '方案名称',
    key: 'name',
    type: 'input',
    labelCol: {
      span: 24,
    },
    placeholder: '请输入',
    rules: [
      {
        required: true,
        trigger: ['blur'],
        message: '请输入方案名称',
      },
    ],
  },
])

defineProps({
  open: { type: Boolean, required: true }
})
const emits = defineEmits(['cancel', 'ok'])

const formRef = ref()

const onSave = async () => {
  await formRef.value.validate()
  emits('ok', formData.value.name)
}

const formData = ref({ name: '' })
</script>
